export const showGlobalLoading = (message: string = "") => {
  const event = new CustomEvent("showLoading", {
    detail: { message },
  });
  window.dispatchEvent(event);
};

export const hideGlobalLoading = () => {
  const event = new CustomEvent("hideLoading");
  window.dispatchEvent(event);
};
